<div class="page">
  <div class="subheader">
    <i class="subicon icon-angle-double-left" (click)="order.closeSidebar()"></i>
    <i class="usericon icon-person_outline-F"></i><span class="title-header">{{'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.WaiterFastacces.TitleHeader'| translate }}</span>
  </div>

  <div class="infobox" *ngIf="order.waiters?.length <= 0">
    <div class="subinfobox">
      {{'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.WaiterFastacces.GarsonMessage'| translate }}
    </div>
  </div>

  <div class="infobox">
    <div *ngFor="let personnel of this.order.waiters" class="subinfobox" (click)="SetInvoiceWaiter(personnel)">
      <i class="usericonsub icon-person_outline-F"></i> <span class="listtext"> {{personnel.DisplayName}}</span>
    </div>
  </div>
</div>
